import React, { Component } from 'react';
import * as Styles from './Styles';

type Props = {
	label: string;
	active: boolean;
	onClick: () => void;
};

type State = {};

class NavButton extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.NavButtonWrapper
				active={this.props.active}
				onClick={() => this.props.onClick()}
			>
				{this.props.label}
			</Styles.NavButtonWrapper>
		);
	}
}

export default NavButton;
